export default "__VITE_ASSET__BMuJsk9J__"